
export const progressBarStyle = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  position: "relative",
  mb: 1
};

export const stepsWrapperStyle = (isClickable = false, tabsAmount = 1) => ({
  flex: "1 1 20%",
  textAlign: "center",
  cursor: isClickable ? "pointer" : "default",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: `${100 / tabsAmount}%`
})